module.exports = __webpack_public_path__ + "img/compartilhar.37c4f87a.svg";